/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Metadata for one active document. Bytes are NOT included (fetched separately).
 * @export
 * @interface PamDocumentSummary
 */
export interface PamDocumentSummary {
    /**
     * 
     * @type {string}
     * @memberof PamDocumentSummary
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentSummary
     */
    uploadedBy: string;
    /**
     * 
     * @type {number}
     * @memberof PamDocumentSummary
     */
    byteSize: number;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentSummary
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentSummary
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof PamDocumentSummary
     */
    id: string;
}

/**
 * Check if a given object implements the PamDocumentSummary interface.
 */
export function instanceOfPamDocumentSummary(value: object): value is PamDocumentSummary {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('uploadedBy' in value) || value['uploadedBy'] === undefined) return false;
    if (!('byteSize' in value) || value['byteSize'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PamDocumentSummaryFromJSON(json: any): PamDocumentSummary {
    return PamDocumentSummaryFromJSONTyped(json, false);
}

export function PamDocumentSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamDocumentSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'uploadedBy': json['uploadedBy'],
        'byteSize': json['byteSize'],
        'contentType': json['contentType'],
        'fileName': json['fileName'],
        'id': json['id'],
    };
}

export function PamDocumentSummaryToJSON(value?: PamDocumentSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'uploadedBy': value['uploadedBy'],
        'byteSize': value['byteSize'],
        'contentType': value['contentType'],
        'fileName': value['fileName'],
        'id': value['id'],
    };
}

